import _ from 'lodash';
import ItemComponent from "../../../../core/infraestructure/ItemComponent";
import CourseViewModel from "../../../../core/features/website/viewmodels/CourseViewModel";

export default {
  extends: ItemComponent,
  data() {
    return {
      viewModel: null,
    };
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.viewModel = new CourseViewModel(this);
  },
  methods: {
    orderSubjects(collection) {
      return _.sortBy(collection, "sort");
    }
  },
};
